// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.chatbot-application-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 90px;
    background-color:#fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;
}

/* Left Section - Image */
.chatbot-application-image {
    position: relative;
    width: 22%;
    order: 1; /* Place image on the left */

    margin-top: 30px;
}

.services-image {
    width: 100%;
    height: 50%;
    border-radius: 8px;
    margin: 0; /* Remove any default margin on the image */
    display: block; /* Ensure the image behaves as a block element */
}

/* Right Section - Content */
.chatbot-application-text {
    width: 62%;
    order: 2; /* Place content on the right */
   /* Add some padding to the text section for balance */
    margin-top: -45px;
    margin-right: 65px;
}


.chatbot-application-text h1 {
    margin-top: 20px; /* Adjust heading margin to move it upwards */
  margin-bottom: 10px;
  font-size: 2.0rem;
  color: #333;
  text-align: left;
}
.chatbot-application-text h2
 {
    font-size: 1em;
    color: #555;
    margin-bottom: 20px;
}

.services-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    list-style: none;
    padding: 0;
}

.services-list li {
    width: 45%;
    font-size: 0.9em;
    color: #333;
}

/* Button */
.chatbot-application-button {
    background-color: #00c853;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1em;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
    transition: background-color 0.3s ease;
}

.chatbot-application-button:hover {
    background-color: #009624;
}

/* Responsive Design */
@media (max-width: 768px) {
    .chatbot-application-container {
        flex-direction: column; /* Stack items for smaller screens */
        align-items: left;
        text-align: left;
        gap: 20px;
    }

    .chatbot-application-text {
        width: 150%;
        margin-right:10px;
        order: 2; /* Maintain order for responsive layout */
    }

    .chatbot-application-image {
        width: 150%;
        margin-top:50px;
        order: 1; /* Maintain order for responsive layout */
    }

    .services-list li {
        width: 100%;
    }
}

@media (min-width: 1380px) and (max-width: 1919px) {
    .chatbot-application-container {
        max-width: 1400px;
        margin: 0 auto;
        padding: 90px;
    }

    .chatbot-application-image {
        width: 19%;
        margin-top: 60px;
        margin-left:50px;
    }

    .chatbot-application-text {
        width: 68%;
        margin-top: -10px;
        
    }

    .chatbot-application-text h1 {
        font-size: 1.8rem;
    }

    .chatbot-application-text p {
        font-size: 0.95em;
    }

    .services-list li {
        width: 48%;
    }

    .chatbot-application-button {
        font-size: 1em;
        padding: 10px 18px;
    }
}

/* Styles for Large Screens (1920px and Above) */
@media (min-width: 1920px) {
    .chatbot-application-container {
        max-width: 1600px;
        margin: 0 auto;
        padding: 100px;
    }

    .chatbot-application-image {
        width: 40%;
        margin-top: 0;
    }

    .chatbot-application-text {
        width: 55%;
        margin-top: 0;
    }

    .chatbot-application-text h1 {
        font-size: 2.5rem;
    }

    .chatbot-application-text p {
        font-size: 1.1rem;
    }

    .services-list li {
        width: 42%;
    }

    .chatbot-application-button {
        font-size: 1.1em;
        padding: 15px 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatbotApplication/ChatbotApplication.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,wCAAwC;IACxC,SAAS;AACb;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAE,4BAA4B;;IAEtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,2CAA2C;IACtD,cAAc,EAAE,gDAAgD;AACpE;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,QAAQ,EAAE,+BAA+B;GAC1C,qDAAqD;IACpD,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB,EAAE,6CAA6C;EACjE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;;IAEI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB,EAAE,oCAAoC;QAC5D,iBAAiB;QACjB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,WAAW;QACX,eAAe;QACf,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,iBAAiB;;IAErB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":["/* Main container */\n.chatbot-application-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 90px;\n    background-color:#fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n}\n\n/* Left Section - Image */\n.chatbot-application-image {\n    position: relative;\n    width: 22%;\n    order: 1; /* Place image on the left */\n\n    margin-top: 30px;\n}\n\n.services-image {\n    width: 100%;\n    height: 50%;\n    border-radius: 8px;\n    margin: 0; /* Remove any default margin on the image */\n    display: block; /* Ensure the image behaves as a block element */\n}\n\n/* Right Section - Content */\n.chatbot-application-text {\n    width: 62%;\n    order: 2; /* Place content on the right */\n   /* Add some padding to the text section for balance */\n    margin-top: -45px;\n    margin-right: 65px;\n}\n\n\n.chatbot-application-text h1 {\n    margin-top: 20px; /* Adjust heading margin to move it upwards */\n  margin-bottom: 10px;\n  font-size: 2.0rem;\n  color: #333;\n  text-align: left;\n}\n.chatbot-application-text h2\n {\n    font-size: 1em;\n    color: #555;\n    margin-bottom: 20px;\n}\n\n.services-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    list-style: none;\n    padding: 0;\n}\n\n.services-list li {\n    width: 45%;\n    font-size: 0.9em;\n    color: #333;\n}\n\n/* Button */\n.chatbot-application-button {\n    background-color: #00c853;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1em;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: background-color 0.3s ease;\n}\n\n.chatbot-application-button:hover {\n    background-color: #009624;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .chatbot-application-container {\n        flex-direction: column; /* Stack items for smaller screens */\n        align-items: left;\n        text-align: left;\n        gap: 20px;\n    }\n\n    .chatbot-application-text {\n        width: 150%;\n        margin-right:10px;\n        order: 2; /* Maintain order for responsive layout */\n    }\n\n    .chatbot-application-image {\n        width: 150%;\n        margin-top:50px;\n        order: 1; /* Maintain order for responsive layout */\n    }\n\n    .services-list li {\n        width: 100%;\n    }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n    .chatbot-application-container {\n        max-width: 1400px;\n        margin: 0 auto;\n        padding: 90px;\n    }\n\n    .chatbot-application-image {\n        width: 19%;\n        margin-top: 60px;\n        margin-left:50px;\n    }\n\n    .chatbot-application-text {\n        width: 68%;\n        margin-top: -10px;\n        \n    }\n\n    .chatbot-application-text h1 {\n        font-size: 1.8rem;\n    }\n\n    .chatbot-application-text p {\n        font-size: 0.95em;\n    }\n\n    .services-list li {\n        width: 48%;\n    }\n\n    .chatbot-application-button {\n        font-size: 1em;\n        padding: 10px 18px;\n    }\n}\n\n/* Styles for Large Screens (1920px and Above) */\n@media (min-width: 1920px) {\n    .chatbot-application-container {\n        max-width: 1600px;\n        margin: 0 auto;\n        padding: 100px;\n    }\n\n    .chatbot-application-image {\n        width: 40%;\n        margin-top: 0;\n    }\n\n    .chatbot-application-text {\n        width: 55%;\n        margin-top: 0;\n    }\n\n    .chatbot-application-text h1 {\n        font-size: 2.5rem;\n    }\n\n    .chatbot-application-text p {\n        font-size: 1.1rem;\n    }\n\n    .services-list li {\n        width: 42%;\n    }\n\n    .chatbot-application-button {\n        font-size: 1.1em;\n        padding: 15px 25px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
